import lodash from 'lodash'
import moment from 'moment'

export default {
  getTenders(state) {
    return state.tenders
  },
  getTendersCount(state) {
    return state.tendersCount
  },
  gettendersCountsByTypes(state) {
    return state.tendersCountsByTypes
  },
  getTender(state) {
    return state.tender
  },
  clearNewTender(state) {
    return state.newTender = lodash.cloneDeep(state.defaultTender)
  },
  getNewTender(state) {
    if (state.newTender) {
      return state.newTender
    } else {
      return state.newTender = lodash.cloneDeep(state.defaultTender)
    }
  },
  getDefaultTender(state) {
    return state.defaultTender
  },
  getNewTenderInfo(state) {
    return state.NewTenderInfo
  },
  getClassifications(state) {
    return state.classifications
  },
  getBiddingTypes(state) {
    return state.biddingTypes
  },
  getBiddingAllTypes(state) {
    return state.allBiddingTypes
  },
  getProlongationRule(state) {
    return state.prolongationRule
  },
  getTenderContactPersons(state) {
    return state.tenderContactPersons
  },
  getAdditionalContactPeople(state) {
    return state.additionalTenderContactPersons
  },
  getCriteria(state) {
    return state.criteria
  },
  getTreeView(state) {
    return state.treeView
  },
  getMesurementUnit(state) {
    return state.mesurementUnit
  },
  getTopMesurementUnit(state) {
    return state.topMesurementUnit
  },
  getCompareItems(state) {
    return state.compareItems
  },
  getCurrencies(state) {
    return state.currencies
  },
  getSubcategories(state) {
    return state.subcategories
  },
  getResourcesItems(state) {
    return state.tenderResources
  },
  getTenderStatuses(state) {
    return state.tenderStatuses
  },
  getDepartments(state) {
    return state.departments || []
  },
  getNbuCurrencyRate(state) {
    return state.nbuCurrencyRate
  },
  getNbuCurrencyRateByCurrencyId: (state) => (currencyId) => {
    return state.nbuCurrencyRate[currencyId]
  },
  getTenderAllStatuses(state) {
    return state.tenderAllStatuses
  },
  getTendersSettings(state) {
    return state.tenderSettings
  },
  getSupplierAddress(state) {
    return state.supplierAddress
  },
  getTenderProfile(state) {
    return state.tenderProfile
  },
  getHolidays(state) {
    return state.holidays
  },
  getMinPproposalsDate(state) {
    if (state.newTender?.isUrgent || state.tender?.isUrgent) {
      return moment()
    }
    return state.min_proposals_date
  },
  getStageAgreements(state) {
    return state.agreements
  },
  getCriterionCards(state) {
    return state.criterion_cards
  },
  getAvailableCards(state) {
    return state.availableCards
  },
  getStandartCriteria(state) {
    return state.standart_criteria
  },
  getCriteriaCardById: (state) => (id) => {
    return state.criterion_cards_by_id[id]
  },
  getCriteriaCardTemplates(state) {
    return state.criteria_card_templates
  },
  getFilters(state) {
    return state.filters
  },
  personalManagers(state) {
    return state.personalManagers
  },
  getFiltersTemplatesByType(state) {
    return state.filters_templates
  },
}
